import React from "react";

export default (props) => {
  const Component = props.as || "h1";
  return <Component className="mega">{props.children}</Component>;
};
